module.exports = __webpack_public_path__ + "static/media/add-debit-card.ae3ba368.png";